import { Resource } from "@app/resources";

export interface AccuracyTemplateCollectionMetadata {
  templateCollectionId: string;
  resource: Resource;
  templates?: AccuracyTemplateMetadata[];
  correlationIds?: string[];
}

export interface AccuracyTemplateMetadata {
  templateCollectionId: string;
  templateId: string;
  templateName: string;
  templateDescription: string;
  createdDate: Date;
  correlationId: string;
}

export enum QueryType {
  Unknown = "unknown",
  Full = "full",
  Sample = "sample",
}

export enum PointStyle {
  Unknown = "unknown",
  Good = "good",
  Bad = "bad",
}

export enum RowScoreMethod {
  Unknown = "unknown",
  Average = "average",
  Max = "max",
  Min = "min",
  Sum = "sum",
}

export enum AggregateScoreMethod {
  Unknown = "unknown",
  Average = "average",
  Index = "index",
  Percent = "percent",
  PercentOfMax = "percentOfMax",
}

export interface AccuracyTemplateInspector {
  guid?: string;
}

export interface AccuracyTemplateInspection {
  uid?: string;
  name?: string;
  className?: string;
  inspector?: AccuracyTemplateInspector;
  results?: AccuracyTemplateInspectionResult[];
}

export interface AccuracyTemplateInspectionGroup {
  uid?: string;
  name?: string;
  weight?: string;
  inspections?: AccuracyTemplateInspection[];
}

export interface AccuracyTemplateCriteria {
  inspectionGroups?: AccuracyTemplateInspectionGroup[];
}

export interface AccuracyTemplateInspectionResult {
  result?: string;
  points?: number;
}

export interface AccuracyTemplateScope {
  queryType?: QueryType;
  onlyTruthSourceMatched?: boolean;
  sampling?: AccuracyTemplateScopeSampling;
}

export interface AccuracyTemplateScopeSampling {
  sampleSize?: number;
  iterations?: number;
}

export interface AccuracyTemplateScoring {
  maxPoints?: number;
  pointStyle?: PointStyle;
  rowScoreMethod?: RowScoreMethod;
  aggregateScoreMethod?: AggregateScoreMethod;
  bandGroups?: AccuracyTemplateScoringBandGroup[];
}

export interface AccuracyTemplateScoringBand {
  uid?: string;
  name?: string;
  range?: AccuracyTemplateScoringBandRange;
  bandColor?: string;
}

export interface AccuracyTemplateScoringBandGroup {
  uid?: string;
  name?: string;
  bands?: AccuracyTemplateScoringBand[];
}

export interface AccuracyTemplateScoringBandRange {
  minPoints?: number;
  maxPoints?: number;
}

export interface AccuracyTemplate {
  name?: string;
  temporalPosition?: Date;
  scope?: AccuracyTemplateScope;
  scoring?: AccuracyTemplateScoring;
  criteria?: AccuracyTemplateCriteria;
}

export interface AccuracySpecialtyDefinition {
  specialtyDefinitionId: number;
  name: string;
  categories: CategoryModel[];
}

export interface AccuracySpecialtyDefinitionMetadata {
  specialtyDefinitionId: number;
  resource: Resource;
  blobName: string;
  contentHash: Uint8Array[];
}

export interface SpecialtyModel {
  code: string;
  name: string;
}

export interface CategoryModel {
  displayName: string;
  specialtyGroups: SpecialtyGroupModel[];
}

export interface SpecialtyGroupModel {
  code: string;
  displayOrder: number;
  name: string;
  specialties: SpecialtyModel[];
}
